import arEG from 'antd/locale/ar_EG';
import deDE from 'antd/locale/de_DE';
import enUS from 'antd/locale/en_US';
import frFR from 'antd/locale/fr_FR';

const AllAntdLocales = {
    enUS,
    arEG,
    frFR,
    deDE
};

export default AllAntdLocales;
